/**
 * ハイク速度の基本モデル（docs/03_simulation.md 6 章）。
 * gen（経路の形を決めるコスト）と sim（選手の移動）の両方が使うため core に置く。
 * 係数は config/balance.ts にあり、呼び出し側が渡す。
 */

/** Tobler のハイキング関数（km/h）。grade は高低差 / 水平距離 */
export function toblerKmh(grade: number): number {
  return 6 * Math.exp(-3.5 * Math.abs(grade + 0.05));
}

/** これより急な上り・下りは、つづら折りで登り降りする（道の勾配はこの値のまま） */
const SWITCHBACK_UP = 0.28;
const SWITCHBACK_DOWN = -0.35;

/**
 * 歩行速度（m/s、水平）。factor は基本係数 × 地形 × 能力値などの補正をすべて掛けたもの。
 * 急な斜面は、つづら折りの勾配で歩いたときと同じ「鉛直の速さ」で登り降りする
 * （まっすぐ登ると Tobler 関数では極端に遅くなるため）
 */
export function hikeSpeedMs(grade: number, factor: number): number {
  let kmh: number;
  if (grade > SWITCHBACK_UP) kmh = (toblerKmh(SWITCHBACK_UP) * SWITCHBACK_UP) / grade;
  else if (grade < SWITCHBACK_DOWN) kmh = (toblerKmh(SWITCHBACK_DOWN) * SWITCHBACK_DOWN) / grade;
  else kmh = toblerKmh(grade);
  return (kmh * factor) / 3.6;
}

/** Tobler 関数の最大値（km/h）。経路探索のヒューリスティックに使う */
export const TOBLER_MAX_KMH = 6;

/** 上り・下りの補正を掛けたときの最大速度（km/h、係数 1 あたり）。経路探索のヒューリスティック用 */
export function maxHikeKmh(upFactor: number, downFactor: number): number {
  return Math.max(TOBLER_MAX_KMH, toblerKmh(0.05) * upFactor, toblerKmh(-0.1) * downFactor);
}
